import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

import React, { FC, useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ItemTrackingResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.KGPState.ItemTrackingStore.itemTrackingCollection?.pagination,
    };
};

export const resultCountStyles: ItemTrackingResultCountStyles = {
    orderCountText: {
        weight: 600,
    },
};

const styles = resultCountStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const ItemTrackingResultCount: FC<Props> = ({ pagination }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="itemTracking_resultCount">
            {totalItemCount} {translate("product history record{0} were returned", totalItemCount > 1 ? "(s)" : "")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ItemTrackingResultCount),
    definition: {
        group: "Common",
        displayName: " Item Tracking Result Count",
    },
};

export default widgetModule;
